import { createContext } from "react"
import { AtribuirRegiaoInicial } from "../models/atribuirRegiaoModel"
import type { AtribuirRegiaoModel, BairroRegiao } from "../models/atribuirRegiaoModel"
import type { AtribuirRegiaoActionModel } from "./atribuirRegiaoActions"

type AtribuirRegiaoContextProps = {
    dados: AtribuirRegiaoModel
    dispatch: React.Dispatch<AtribuirRegiaoActionModel>
    salvar: () => Promise<void>
    removerBairro: (index: number, bairro: BairroRegiao) => Promise<void>
    adicionarCidade: (idCidade: number) => Promise<void>
    removerCidade: (idCidade: number) => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: AtribuirRegiaoContextProps = {
    dados: AtribuirRegiaoInicial,
    dispatch: () => {},
    salvar: async () => {},
    removerBairro: async () => {},
    adicionarCidade: async () => {},
    removerCidade: async () => {},
    erroCarregamento: null,
}

export const AtribuirRegiaoContext =
    createContext<AtribuirRegiaoContextProps>(initialContextValue)
